export var SurveyStatus;
(function (SurveyStatus) {
    SurveyStatus["DRAFT"] = "DRAFT";
    SurveyStatus["PUBLISHED"] = "PUBLISHED";
})(SurveyStatus || (SurveyStatus = {}));
export var SurveyType;
(function (SurveyType) {
    SurveyType["PRE_STAY"] = "PRE_STAY";
    SurveyType["POST_STAY"] = "POST_STAY";
    SurveyType["PRE_SERVICE"] = "PRE_SERVICE";
    SurveyType["POST_SERVICE"] = "POST_SERVICE";
    SurveyType["ANONYMOUS"] = "ANONYMOUS";
})(SurveyType || (SurveyType = {}));
export var SurveyFormat;
(function (SurveyFormat) {
    SurveyFormat["SINGLE_PAGE"] = "SINGLE_PAGE";
    SurveyFormat["MULTI_PAGE"] = "MULTI_PAGE";
    SurveyFormat["SECTIONS"] = "SECTIONS";
})(SurveyFormat || (SurveyFormat = {}));
export var SurveyQuestionType;
(function (SurveyQuestionType) {
    SurveyQuestionType["WELCOME"] = "WELCOME";
    SurveyQuestionType["GENERIC_SCORE"] = "GENERIC_SCORE";
    SurveyQuestionType["GENERIC_STARS"] = "GENERIC_STARS";
    SurveyQuestionType["MULTIPLE_CHOICE"] = "MULTIPLE_CHOICE";
    SurveyQuestionType["PICTURE_CHOICE"] = "PICTURE_CHOICE";
    SurveyQuestionType["DROPDOWN"] = "DROPDOWN";
    SurveyQuestionType["YES_NO"] = "YES_NO";
    SurveyQuestionType["SHORT_TEXT"] = "SHORT_TEXT";
    SurveyQuestionType["LONG_TEXT"] = "LONG_TEXT";
    SurveyQuestionType["DATE"] = "DATE";
    SurveyQuestionType["NUMBER"] = "NUMBER";
    SurveyQuestionType["CHECKLIST"] = "CHECKLIST";
    SurveyQuestionType["LEGAL"] = "LEGAL";
    SurveyQuestionType["UPLOAD_MEDIA"] = "UPLOAD_MEDIA";
    SurveyQuestionType["END_SCREEN"] = "END_SCREEN";
})(SurveyQuestionType || (SurveyQuestionType = {}));
export var SurveyFont;
(function (SurveyFont) {
    SurveyFont["ROBOTO"] = "ROBOTO";
    SurveyFont["INTER"] = "INTER";
    SurveyFont["PUBLIC_SANS"] = "PUBLIC_SANS";
    SurveyFont["POPPINS"] = "POPPINS";
})(SurveyFont || (SurveyFont = {}));
export var SurveyCornerStyle;
(function (SurveyCornerStyle) {
    SurveyCornerStyle["SQUARE"] = "SQUARE";
    SurveyCornerStyle["SOFT"] = "SOFT";
    SurveyCornerStyle["ROUNDED"] = "ROUNDED";
})(SurveyCornerStyle || (SurveyCornerStyle = {}));
export var SurveyBannerVariant;
(function (SurveyBannerVariant) {
    SurveyBannerVariant["CONTAINED"] = "CONTAINED";
    SurveyBannerVariant["FULL_WIDTH"] = "FULL_WIDTH";
})(SurveyBannerVariant || (SurveyBannerVariant = {}));
export var SurveyContentAlignment;
(function (SurveyContentAlignment) {
    SurveyContentAlignment["TOP"] = "TOP";
    SurveyContentAlignment["CENTER"] = "CENTER";
    SurveyContentAlignment["BOTTOM"] = "BOTTOM";
})(SurveyContentAlignment || (SurveyContentAlignment = {}));
export var SurveyQuestionStyle;
(function (SurveyQuestionStyle) {
    SurveyQuestionStyle["CARDS"] = "CARDS";
    SurveyQuestionStyle["PLAIN"] = "PLAIN";
})(SurveyQuestionStyle || (SurveyQuestionStyle = {}));
export var SurveyProgressStyle;
(function (SurveyProgressStyle) {
    SurveyProgressStyle["SEGMENTS"] = "SEGMENTS";
    SurveyProgressStyle["BAR"] = "BAR";
})(SurveyProgressStyle || (SurveyProgressStyle = {}));
